/**
 * What: Canonical methodology label contracts for evidence, grounding, and source provenance.
 * Transport / data-flow: Pure in-memory constants, Zod schemas, and JSON Schema fragments shared by product, MCP, report, and future intake-plan surfaces.
 *
 */
import * as z from 'zod';
export const evidenceStateValues = ['unsupported', 'directional', 'benchmarked', 'calibrated', 'deprecated'];
export const fieldGroundingStatusValues = [
    'observed',
    'sampled_from_joint_observed',
    'sampled_from_marginal_observed',
    'sampled_from_observed',
    'benchmark_only',
    'derived',
    'stimulus_context_only',
    'model_prior_only',
    'unsupported',
];
export const groundingSourceTypeValues = [
    'population_field',
    'supplied_human_data',
    'weighted_human_data',
    'cross_tab_sampled',
    'first_party_analytics',
    'brand_tracker',
    'media_panel',
    'public_benchmark',
    'calibration_survey',
    'public_web_entity_record',
    'websets_source_record',
    'stimulus_context',
    'model_prior_only',
];
export const profileOverlayRoleValues = [
    'eligibility',
    'quota',
    'conditioning',
    'segmentation',
    'diagnostic_only',
    'excluded',
];
export const evidenceStateSchema = z.enum(evidenceStateValues);
export const fieldGroundingStatusSchema = z.enum(fieldGroundingStatusValues);
export const groundingSourceTypeSchema = z.enum(groundingSourceTypeValues);
export const profileOverlayRoleSchema = z.enum(profileOverlayRoleValues);
export const evidenceStateJsonSchema = {
    type: 'string',
    enum: evidenceStateValues,
};
export const fieldGroundingStatusJsonSchema = {
    type: 'string',
    enum: fieldGroundingStatusValues,
};
export const groundingSourceTypeJsonSchema = {
    type: 'string',
    enum: groundingSourceTypeValues,
};
export const profileOverlayRoleJsonSchema = {
    type: 'string',
    enum: profileOverlayRoleValues,
};
export const methodologyLabelJsonSchemas = {
    evidenceState: evidenceStateJsonSchema,
    fieldGroundingStatus: fieldGroundingStatusJsonSchema,
    groundingSourceType: groundingSourceTypeJsonSchema,
    profileOverlayRole: profileOverlayRoleJsonSchema,
};
//# sourceMappingURL=methodology-labels.js.map